"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectionConfigMethods = void 0;
const config = (collection, property) => property
    ? collection.metadata.propertiesConfig.find(({ property_name }) => property_name === property)
    : collection.metadata.config;
exports.collectionConfigMethods = {
    title(property) {
        var _a;
        return ((_a = config(this, property)) === null || _a === void 0 ? void 0 : _a.title) || property || this.name;
    },
    documentTitle() {
        var _a;
        return ((_a = this.metadata.config) === null || _a === void 0 ? void 0 : _a.document_title) || this.name;
    },
    description(property) {
        var _a;
        return ((_a = config(this, property)) === null || _a === void 0 ? void 0 : _a.description) || '';
    },
    icon(property) {
        var _a;
        return ((_a = config(this, property)) === null || _a === void 0 ? void 0 : _a.icon) || '';
    },
    defaultView() {
        var _a;
        return ((_a = this.metadata.config) === null || _a === void 0 ? void 0 : _a.default_view) || 'table';
    }
};
//# sourceMappingURL=config.js.map